module.exports = __webpack_public_path__ + "img/keystore-file.cd9a1369.jpg";